import { PlusOutlined } from '@ant-design/icons';
import {
    Breadcrumb,
    Button,
    Col,
    Form,
    Input,
    Row,
    Select,
    Upload,
    message
} from 'antd';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { createUser } from '../../slices/user';
import { fetchUserGroupList, resetUserGroupList } from '../../slices/user-group';

const { Option } = Select;

function AddUser() {
    const [form] = Form.useForm();
    let navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const [fileList, setFileList] = useState([]);
    const dispatch = useDispatch();
    const { list: userGroupList } = useSelector((state) => state.userGroup);

    useEffect(() => {
        dispatch(resetUserGroupList());
        dispatch(fetchUserGroupList({ page: 1, pagesize: 10 }));
    }, []);

    const validateFileList = () => {
        const fileType = fileList[0]?.type;
        if (fileList.length > 0 && !["image/jpeg", "image/jpg", "image/png"].includes(fileType)) {
            return Promise.reject(new Error("Only JPG, JPEG, or PNG files are allowed!"));
        }
        return Promise.resolve();
    };

    const handleFileChange = (info) => {
        const newFileList = info.fileList.slice(-1); // Limit to one file
        setFileList(newFileList);
    };

    const handleFinish = (values) => {
        setBtnLoading(true);
        let profilePic = fileList[0]?.originFileObj;
        dispatch(createUser({ values, profilePic }))
            .unwrap()
            .then((result) => {
                setBtnLoading(false);
                if (result.success) {
                    message.success(result.message);
                    navigate('/manage-user');
                } else {
                    message.error(result.message);
                }
            })
            .catch((error) => {
                setBtnLoading(false);
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }

                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error);
                } else if (error instanceof Error) {
                    message.error(error.message);
                } else {
                    message.error('An unknown error occurred.');
                }
            });
    };


    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow mb-0" justify="space-between" align="middle">
                    <Col>
                        <h2 style={{ margin: 0 }}>Add New User</h2>
                        <div className="bredcrumbwrp">
                            <Link onClick={() => navigate(-1)} className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/dashboard">Home</Link> },
                                    { title: <Link to="/manage-user">Users</Link> },
                                    { title: 'Add New User' },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="formwrapper">
                <Form layout="vertical" form={form} onFinish={handleFinish} autoComplete="off">
                    <Row gutter={[16, 16]} className="viewform">
                        <Col xs={24} sm={3}>
                            <Form.Item label="Profile Image" name="profile_image"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
                                rules={[
                                    {
                                        validator: validateFileList,
                                    },
                                ]}>
                                <Upload
                                    beforeUpload={() => false} // Prevent automatic upload
                                    listType="picture-card"
                                    accept=".jpeg,.jpg,.png"
                                    maxCount={1} // Limit to 1 file
                                    onChange={handleFileChange} // Update the state
                                    fileList={fileList} // Bind fileList state
                                >
                                    {fileList.length < 1 && ( // Show placeholder only if no files uploaded
                                        <div>
                                            <PlusOutlined />
                                            <div
                                                style={{
                                                    marginTop: 8,
                                                }}
                                            >
                                                Upload
                                            </div>
                                        </div>
                                    )}
                                </Upload>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={21} >
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="Username"
                                        name="username"
                                        rules={[
                                            { required: true, message: 'Please enter username' },
                                            {
                                                pattern: /^[A-Za-z0-9@.+\-_]+$/,
                                                message: 'Only letters, digits, and @/./+/-/_ are allowed',
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter User Name"
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                value = value.replace(/[^A-Za-z0-9@.+\-_]/g, '');

                                                const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                                                form.setFieldsValue({ username: formattedValue }); // Update Form state
                                            }} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="First Name"
                                        name="first_name"
                                        rules={[
                                            { required: true, message: 'Please enter first name' },
                                            {
                                                pattern: /^[A-Za-z]+$/,
                                                message: 'Only alphabets are allowed',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter First Name" onChange={(e) => {
                                            let value = e.target.value;
                                            value = value.replace(/[^A-Za-z]/g, ''); const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                                            form.setFieldsValue({ first_name: formattedValue }); // Update Form state
                                        }} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="Last Name"
                                        name="last_name"
                                        rules={[
                                            { required: true, message: 'Please enter last name' },
                                            {
                                                pattern: /^[A-Za-z]+$/,
                                                message: 'Only alphabets are allowed',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter Last Name" onChange={(e) => {
                                            let value = e.target.value;
                                            value = value.replace(/[^A-Za-z]/g, '');
                                            const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                                            form.setFieldsValue({ last_name: formattedValue }); // Update Form state
                                        }} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="Email Address"
                                        name="email"
                                        rules={[
                                            { required: true, message: 'Please enter email' },
                                            { type: 'email', message: 'Please enter a valid email address' },
                                        ]}
                                    >
                                        <Input placeholder="Enter Email Address"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="Phone Number"
                                        name="phone"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter your phone number!',
                                            },
                                        ]}
                                    >
                                        <PhoneInput
                                            country={'in'} // Default country (India)
                                            enableSearch={true} // Enable searching for countries
                                            placeholder="Enter phone number"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xxl={6}>
                                    <Form.Item
                                        label="Role"
                                        name="groups"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select role',
                                            },
                                        ]}
                                    >
                                        <AutoOpenSelect placeholder="Select Role" mode="multiple">
                                            {userGroupList.map((el) => (
                                                <Option key={el.id} value={el.name}>
                                                    {el.name}
                                                </Option>
                                            ))}
                                        </AutoOpenSelect>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <div className="flex justify-end">
                        <Form.Item className="mb-0">

                            <Button type="primary" htmlType="submit" loading={btnLoading} icon={<PlusOutlined />}>
                                Add User
                            </Button>

                        </Form.Item>
                    </div>

                </Form >
            </div>
        </>
    );
}

export default AddUser;
